module.exports = __webpack_public_path__ + "media/images/flags/32/Ukraine-2de8bebc6f1e165c9fd49e66b1f6347b.png";